import * as urls from "../../../api/urls";
import React, { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import Loader from "components/Loader";
import MasterPage1Column from "pages/MasterPage1Column";
import TextBox from "components/TextBox";
import classnames from "classnames";
import { useDialog } from "DialogProvider";
import { useCursorPopup, useRedux } from "hooks";
import { sp_HookSearch, } from "types";

interface MainComponentProps {
  onHookCountChanged(hookCount: number): void;
}

// const MainComponent: React.FC<{ taskCount }> = ({ taskCount: number }) => {
const MainComponent = ({ onHookCountChanged }: MainComponentProps) => {

  const { dispatch, useAppSelector } = useRedux();
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<sp_HookSearch[]>([]);
  const [keyword, setKeyword] = useState<string>("");
  const [ddlRespondBy, setDdlRespondBy] = useState<any[]>([]);
  const [ddlDivision, setDdlDivision] = useState<any[]>([]);
  const [ddlSelectedRespondBy, setDdlSelectedRespondBy] = useState<any>();
  const [ddlSelectedDivision, setDdlSelectedDivision] = useState<any>();

  useEffect(() => {
    fnSearch();
  }, []);

  useEffect(() => {
    onHookCountChanged((data ?? []).length);
  }, [data]);

  const fnSearch = async () => {
    setLoading(true);
    const parm = {
      keyword: keyword,
    }
    new APIClient().fnPostForm(urls.HOOK_SEARCH, parm)
      .then(rs => {
        // console.log('HOOK_SEARCH:', rs);
        setData(rs);
        setLoading(false);
      })
      .catch(er => {
        Utils.HandleException(er, true);
        setLoading(false);
      });
  }

  useEffect(() => {
    fnSearch();
  }, [ddlSelectedRespondBy, ddlSelectedDivision]);

  const fnUpdateHook = async (hookId: number | null, isDelete: boolean) => {
    // console.log('fnUpdateHook:', { hookId, isDelete });
    if (hookId) {
      if (isDelete) {
        setData(prev => prev.filter(x => x.hookId !== hookId));
      } else { // update
        new APIClient().fnPostForm(urls.HOOK_SEARCH, { hookId: hookId })
          .then(rs => {
            if (rs.length === 1) {
              const usr = rs[0];
              setData(prev => {
                const exists = prev.some(t => t.hookId === usr.hookId);
                if (exists) {
                  return prev.map(x =>
                    x.hookId === usr.hookId ? usr : x
                  );
                } else {
                  return [...prev, usr];
                }
              });
            }
          });
      }
    }
  }

  // useEffect(() => {
  //   console.log('data:', data);
  // }, [data]);

  const dialog = useDialog();
  const fnEdit = async (hookId: number) => {
    const rsHookId = await dialog.showHookInfo({ hookId: hookId });
    if (rsHookId != -1) { // -1 = user cancel
      await fnUpdateHook(hookId, hookId != rsHookId);
    }
  }
  const fnAdd = async () => {
    const rsHookId = await dialog.showHookInfo();
    await fnUpdateHook(rsHookId, false);
  }

  const [subTask, setSubTask] = useState<any[]>([]);
  const [curTaskInPop, setCurTaskInPop] = useState<string>("");
  const [subTaskLoading, setSubTaskLoading] = useState<boolean>(false);
  const [showSubTaskDialog, setShowSubTaskDialog] = useState<boolean>(false);
  const { ref: popRef, pos: popCur, openAtCursor } = useCursorPopup(
    showSubTaskDialog,
    () => setShowSubTaskDialog(false)
  );

  const minWidth = popCur.width < 720 ? "calc(100vw - 4px)" : "500px";

  return (
    <div>
      <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
        <div className="row " style={{ flexGrow: "1" }}>
          <div className="col">
            <TextBox placeholder="คำค้นหา" onClear={fnSearch} style={{ padding: "5px" }} icon13css="fas fa-search fz-10 me-1" value={keyword} onChange={(e) => setKeyword(e.target.value)} onEnter13={fnSearch} />
          </div>
        </div>
        <div className="input-group-append">
          <button className="btn btn-warning" type="submit" onClick={fnAdd}>เพิ่ม</button>
        </div>
      </div>
      <div style={{ height: "5px" }}></div>
      {loading && (<Loader />)}
      <div className="div-table-fix-header" style={{ height: "calc(100vh - 120px)" }}>
        <table >
          <thead >
            <tr>
              <th>Event</th>
              <th>Method</th>
              <th>Hook Url</th>
              {/* <th>วันสร้างงาน ถัดไป</th>*/}
              <th>Description</th>
              <th>Update By</th>
              <th>Hooked</th>
              <th>คำสั่ง</th>
            </tr>
          </thead>
          <tbody>
            {!loading && data.length <= 0 && (<tr><td align="center" colSpan={7}>ไม่มีข้อมูล</td></tr>)}
            {data.map((hook, index) => {
              return (
                <tr key={index} className={classnames("hover", { "text-gray": !hook.enabled })} >
                  <td>{Utils.SplitByCase(hook.event ?? "")}</td>
                  <td>{hook.method}</td>
                  <td>{hook.hookUrl}</td>
                  <td>{hook.purpose}</td>
                  <td>{hook.updateByUser}</td>
                  <td align="center" title="Hook count (one year backward)">
                    <span className="text-success">{Utils.FormatNumber(hook.hookCountOk, 0)}</span>
                    &nbsp;-&nbsp;
                    <span className="text-danger">{Utils.FormatNumber(hook.hookCountError, 0)}</span>


                  </td>
                  <td align="center">
                    <div className="d-flex justify-content-center" style={{ gap: "4px" }}>
                      <button title="แก้ไข" className="btn btn-outline-primary fz-11 pt-0 pb-0" onClick={() => fnEdit(hook.hookId!)}>
                        <i className="fas fa-pencil-alt fz-09"></i><span className="hide-xl-bellow">แก้ไข</span>
                      </button>
                      {/* <button title="ดูตารางงานถัดไป" className="btn btn-outline-primary fz-11 pt-0 pb-0" onClick={async () => await Utils.ShowNextTaskRecuranceTable(tk)}>
                        <i className="fa fa-hourglass-1 fz-09"></i><span className="hide-xl-bellow"> งานถัดไป</span>
                      </button> */}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const DataSettingHookManager = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  const [hookCount, setHookCount] = useState<number>(0);

  const onHookCountChanged = (hookCount: number) => {
    setHookCount(hookCount);
  };

  return (
    <MasterPage1Column
      titleText={"Hook Manager" + (hookCount <= 0 ? "" : (` ${hookCount} Hooks`))}
      titleIcon="fas fa-code-branch"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<MainComponent onHookCountChanged={onHookCountChanged} />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingHookManager;